(function () {
    'use strict';

    var _DEFAULT_SEARCH_LOCATION = 'orlando';
    var _DEFAULT_DEPOT_LOCATION = 'orlando-airport';

    function addressing($scope, postCodeAnywhereService) {
        $scope.selectAddress = function () {
            postCodeAnywhereService.fetchAddressById($scope.postcode)
                .success($scope.selectAddressCallback);
        };

        $scope.getAddressesCallback = function (res) {
            $scope.addresses = res.Items;
            $scope.hasPostCodeError = false;
            $scope.showAddressList = true;
        };

        $scope.selectAddressCallback = function (res) {
            var result = res.Items[0];
            $scope.address = {};
            $scope.address.firstLine = result.Line1;
            $scope.address.secondLine = result.Line2;
            $scope.address.town = result.City;
            $scope.manualAddressEntry = true;
            $scope.showAddressList = false;
        };
    }

    angular.module('vhols')

        .controller('MultiPurposeSearchPanelController', ['$scope', '$rootScope', function ($scope, $rootScope) {
            $scope.$watch('searchPanel', function () {
                if ($scope.searchPanel) {
                    var bookingType = parseInt($scope.searchPanel);

                    var criteria = {
                        selectedChildLocation: {
                            locationUrlDescription: _DEFAULT_SEARCH_LOCATION
                        },
                        selectedBookingType: {
                            brand: 205,
                            id: bookingType
                        },
                        selectedDropOffDepot: {
                            locationUrlDescription: _DEFAULT_DEPOT_LOCATION
                        },
                        selectedPickUpDepot: {
                            locationUrlDescription: _DEFAULT_DEPOT_LOCATION
                        },
                        toggleState: false
                    };

                    $rootScope.$emit('SearchPanel:populate', criteria);
                }
            });
        }])

        .controller('HolidayTypesTickListController', ['$scope', function ($scope) {
            $scope.$watch('shouldCollapse', function () {
                if ($scope.shouldCollapse) {
                    $scope.tickCollapse = $scope.shouldCollapse === 'true' ? window.innerWidth < vhols.mobileScreenWidth : false;
                }
            });
        }])

        .controller('htCollapseController', function () { })

        .controller('MultiCentreFormController', ['$scope', 'postCodeAnywhereService', 'dates', function ($scope, postCodeAnywhereService, dates) {
            var _EMPTY = '';
            var NOW = new Date();

            $scope.currentPage = 1;
            $scope.numPages = 2;

            $scope.monthsToShow = 24;
            $scope.date = dates(NOW).asDate();
            $scope.minDate = dates(NOW).asDate();
            $scope.maxDate = dates($scope.date).addMonths($scope.monthsToShow).asDate();


            $scope.changeDown = function(value, levels) {
                levels.forEach(function(level) {
                    $scope[level] = _EMPTY;
                });
            };

            $scope.showStop = function(stop) {
                return parseInt($scope.noStops) >= stop;
            };

            $scope.changeStops = function() {
                var numStops = parseInt($scope.noStops);

                if (!numStops || numStops < 2) {
                    $scope.firstStop = _EMPTY;
                    $scope.secondStop = _EMPTY;
                }

                if (numStops < 3) {
                    $scope.thirdStop = _EMPTY;
                }

                if (numStops < 4) {
                    $scope.fourthStop = _EMPTY;
                }
            };

            $scope.getAddresses = function () {
                try {
                    var postcode = $scope.multiCentreRequest.part_three.postcode.$viewValue;
                    postCodeAnywhereService.postCodeLookup(postcode)
                        .success($scope.getAddressesCallback);
                } catch (e) {
                    $scope.hasPostCodeError = true;
                    $scope.addresses = null;
                }
            };

            addressing($scope, postCodeAnywhereService);
        }])

        .controller('ToursFormController', ['$scope', 'postCodeAnywhereService', 'dates', function ($scope, postCodeAnywhereService, dates) {
            var _EMPTY = '';
            var NOW = new Date();

            $scope.currentPage = 1;
            $scope.numPages = 2;

            $scope.monthsToShow = 24;
            $scope.date = dates(NOW).asDate();
            $scope.minDate = dates(NOW).asDate();
            $scope.maxDate = dates($scope.date).addMonths($scope.monthsToShow).asDate();


            $scope.changeDown = function(value, levels) {
                levels.forEach(function(level) {
                    $scope[level] = _EMPTY;
                });
            };

            $scope.getAddresses = function () {
                try {
                    var postcode = $scope.toursRequest.part_three.postcode.$viewValue;
                    postCodeAnywhereService.postCodeLookup(postcode)
                        .success($scope.getAddressesCallback);
                } catch (e) {
                    $scope.hasPostCodeError = true;
                    $scope.addresses = null;
                }
            };

            addressing($scope, postCodeAnywhereService);
        }])

        .controller('GenericFormController', ['$scope', 'postCodeAnywhereService', function ($scope, postCodeAnywhereService) {

            $scope.getAddresses = function () {
                try {
                    var postcode = $scope.genericForm.postcode.$viewValue;
                    postCodeAnywhereService.postCodeLookup(postcode)
                        .success($scope.getAddressesCallback);
                } catch (e) {
                    $scope.hasPostCodeError = true;
                    $scope.addresses = null;
                }
            };

            addressing($scope, postCodeAnywhereService);
        }])


        .controller('CubaFormController', ['$scope', 'postCodeAnywhereService', 'dates', function ($scope, postCodeAnywhereService, dates) {
            var _EMPTY = '';
            var NOW = new Date();

            $scope.currentPage = 1;
            $scope.numPages = 2;

            $scope.monthsToShow = 24;
            $scope.date = dates(NOW).asDate();
            $scope.minDate = dates(NOW).asDate();
            $scope.maxDate = dates($scope.date).addMonths($scope.monthsToShow).asDate();

            $scope.getAddresses = function () {
                try {
                    var postcode = $scope.cubaRequest.part_three.postcode.$viewValue;
                    postCodeAnywhereService.postCodeLookup(postcode)
                        .success($scope.getAddressesCallback);
                } catch (e) {
                    $scope.hasPostCodeError = true;
                    $scope.addresses = null;
                }
            };

            addressing($scope, postCodeAnywhereService);

        }])

        .filter('range', function() {
            return function (input, min, max) {
                for (var i = min; i < max + 1; i++) {
                    input.push(i);
                }

                return input;
            };
        });
})();
